// extracted by mini-css-extract-plugin
export default {"home":"Home_home__Uh7WZ","showImage":"Home_showImage__vIgWb","videoContainer":"Home_videoContainer__YYVSK"};